import {SiteMenuController} from "./SiteMenuController";
import {HeaderController} from "./header-controller";
import {Singleton} from "../../base/singleton";
import {MenuTriggersController} from "./MenuTriggersController";

class MenuController extends Singleton {
    private readonly SiteMenuController: SiteMenuController;
    private HeaderController: HeaderController;
    private triggers: MenuTriggersController;

    private siteMenuOpen: boolean = false;

    protected constructor() {
        super();
        this.SiteMenuController = SiteMenuController.getInstance();
        this.HeaderController = HeaderController.getInstance();
        this.triggers = MenuTriggersController.getInstance();

        this.render();
        this.watchers();
    }

    private watchers() {
        window.addEventListener('scroll', this.onScroll.bind(this));
        this.triggers.onTriggerClick(this.onTriggerClick.bind(this));
    }

    private onScroll() {

        if (this.SiteMenuController.isMenuOpen()) {
            this.SiteMenuController.close();
        }

        this.render();
    }

    private onTriggerClick() {
        const siteMenu = document.querySelector('.site_menu_inner');
        const bg = siteMenu?.querySelector<HTMLElement>('.site_menu_bg');

        if (this.SiteMenuController.isMenuOpen()) {
            this.unlockScroll();
            this.SiteMenuController.close();

            if (bg) {
                bg.style.opacity = '0';
                bg.classList.remove('filter');
            }

        } else {
            this.lockScroll();
            this.SiteMenuController.open();

            if (bg) {
                bg.style.opacity = '1';
                bg.classList.add('filter');
            }
        }

        this.render();
    }

    private render() {
        const menuOpen = this.SiteMenuController.isMenuOpen();

        if (menuOpen) {
            this.HeaderController.hide();
        } else {
            this.HeaderController.show();
        }
    }

    private isBottomOfPage() {
        return (window.scrollY + 200) + window.innerHeight >= document.body.offsetHeight;
    }

    private lockScroll() {
        document.body.style.overflow = 'hidden';
    }

    private unlockScroll() {
        document.body.style.overflow = 'auto';
    }
}

export default function () {
    MenuController.getInstance();
}